import { createContext } from "react";

const MerchantSensitiveDataContext = createContext<any>({});

export default MerchantSensitiveDataContext;
